import React, {useCallback, useMemo} from 'react'
import PropTypes from 'prop-types'
import MaterialVariationSelection from '../../../components/material-variation-selection'
import ColorVariationSelection from '../../../components/color-variation-selection'
import {useHistory} from 'react-router-dom'
import {usePDPSearchParams} from '../../../hooks/use-pdp-search-params'
import {getMasterProductId} from '../../../utils/product-utils'

/**
 * Render a tile of set product for the customizable psdp - in essence the material and color selectors
 */
const CustomizablePsdpSetProductTile = ({product, onHoverChange}) => {
    const history = useHistory()
    const [allParams, productParams] = usePDPSearchParams(product.setProductId)

    // material change needs special handling to update the pid in the url
    const onMaterialChange = useCallback(
        (value) => {
            productParams.set('pid', value)
            allParams.set(product.setProductId, productParams.toString())

            history.replace({search: allParams.toString()})
        },
        [productParams, allParams, product, history]
    )

    // compute if different master is loading to show appropriate loading state
    const isMasterLoading = useMemo(() => {
        const wantedPid = productParams.get('pid') || product.id
        return (
            // when the wanted pid is not the current product
            wantedPid !== product.id &&
            // and not it's master
            wantedPid !== getMasterProductId(product) &&
            // and neither of the variants - use find to short-circuit when match is found
            // and using the negation handles the case when variants is undefined
            !product.variants?.find((variant) => variant.productId === wantedPid)
        )
    }, [productParams, product])

    return (
        <>
            {/* Material selector */}
            <MaterialVariationSelection product={product} onChange={onMaterialChange} />
            {/* Color selector */}
            <ColorVariationSelection
                product={product}
                isProductASet
                loading={isMasterLoading}
                onHoverChange={onHoverChange}
                labelPrefix={product.c_productShortName}
            />
        </>
    )
}

CustomizablePsdpSetProductTile.propTypes = {
    product: PropTypes.object,
    onHoverChange: PropTypes.func
}

export default CustomizablePsdpSetProductTile
